import { BrowserRouter, Route, Routes } from "react-router-dom"; // Import Routes and Route
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";
import EmbeddedSystems from "./components/EmbeddedSystems"; // Import the new component
import AboutInfo from "./components/AboutInfo";
import Verticals from "./components/Verticals";
import Careers from "./components/Careers";
import ContactInfo from "./components/ContactInfo";
import Its from "./components/Its";
import Hardware from "./components/Hardware";
import Firmware from "./components/Firmware";
import Software from "./components/Software";
import Clients from "./components/Clients";
import Testing from "./components/Testing";
import Partner from "./components/Partner";
import Panel from "./components/Panel";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar /> {/* Always displayed */}
      <Routes>
        <Route path="/" element={<><Header /><Main /></>} />
        <Route path="/Embedded-Systems" element={<EmbeddedSystems /> } />
        <Route path="/About" element={<AboutInfo /> } />
        <Route path="/Verticals" element={<Verticals /> } />
        <Route path="/Careers" element={<Careers /> } />
        <Route path="/Contact" element={<ContactInfo /> } />
        <Route path="/Intelligent-Transport" element={<Its /> } />
        <Route path="/Embedded-Systems/Hardware-Design" element={<Hardware /> } />
        <Route path="/Embedded-Systems/Firmware-Design" element={<Firmware /> } />
        <Route path="/Embedded-Systems/Software-Development" element={<Software /> } />
        <Route path="/Software-Development" element={<Software /> } />
        <Route path="/Clients" element={<Clients /> } />
        <Route path="/Embedded-Systems/Testing" element={<Testing /> } />
        <Route path="/Manufacturing-Partner" element={<Partner  /> } />
        <Route path="/Display-Panel" element={<Panel  /> } />

      </Routes>
      <Footer /> {/* Always displayed */}
    </BrowserRouter>
  );
}

export default App;
